import React from "react";
import HomePageStore from "../HomePageStore";
import { observer, inject } from "mobx-react";
import DiscoverAndBuildTab from "./DiscoverAndBuildTab";
import DiscoverAndBuildItems from "./DiscoverAndBuildItems";

export interface DiscoverAndBuildMobileProps {}

interface InjectedProps extends DiscoverAndBuildMobileProps {
  homePageStore: HomePageStore;
}
const discoverAndBuildMobile: React.SFC<DiscoverAndBuildMobileProps> = (
  props
) => {
  const { homePageStore } = props as InjectedProps;
  const { discoverAndBuild } = homePageStore.homePageContent.response;
  return (
    <div className="subaru_discover_wrapper mobile">
      <div className="subaru-mobile_accordion">
        <DiscoverAndBuildTab
          tabIcon={discoverAndBuild.sedansAndHatchbackIcon}
          tabImage={discoverAndBuild.sedansAndHatchbackImageSm}
          tabName="sedansAndHatchbackVariants"
          tabTitle={discoverAndBuild.sedansAndHatchbackTitle}
          tabMobile={true}
        />
        {homePageStore.selectedTab == "sedansAndHatchbackVariants" && (
          <DiscoverAndBuildItems />
        )}
      </div>

      <div className="subaru-mobile_accordion">
        <DiscoverAndBuildTab
          tabIcon={discoverAndBuild.suVsIcon}
          tabImage={discoverAndBuild.suVsImageSm}
          tabName="suvVariants"
          tabTitle={discoverAndBuild.suvTitle}
          tabMobile={true}
        />
        {homePageStore.selectedTab == "suvVariants" && (
          <DiscoverAndBuildItems />
        )}
      </div>

      <div className="subaru-mobile_accordion">
        <DiscoverAndBuildTab
          tabIcon={discoverAndBuild.performanceIcon}
          tabImage={discoverAndBuild.performanceImageSm}
          tabName="performanceVariants"
          tabTitle={discoverAndBuild.performanceTitle}
          tabMobile={true}
        />
        {homePageStore.selectedTab == "performanceVariants" && (
          <DiscoverAndBuildItems />
        )}
      </div>

      <div className="subaru-mobile_accordion">
        <DiscoverAndBuildTab
          tabIcon={discoverAndBuild.hybridsIcon}
          tabImage={discoverAndBuild.hybridsImageSm}
          tabName="hybridVariants"
          tabTitle={discoverAndBuild.hybridTitle}
          tabMobile={true}
        />
        {homePageStore.selectedTab == "hybridVariants" && (
          <DiscoverAndBuildItems />
        )}
      </div>
    </div>
  );
};

export default inject("homePageStore")(observer(discoverAndBuildMobile));
